/* eslint-disable */
import React from 'react';
import { Container } from '@material-ui/core';
import VerifyIdentityModal from './modal/verify-identity-modal';
import { IEnhancedKYC, IEnhancedKYCSyncResponse } from 'src/services/Types';
import useAppSearchParams from 'src/hooks/useAppSearchParams';
import useLastUrl from 'src/hooks/useLastUrl';
import ValidateOTPModal from './modal/validate-otp-modal';
import { message, Typography } from 'antd';
import { useAppQuery } from 'src/hooks/useAppQuery';

export const SNBLIdentify: React.FC = () => {
  const { getSearchParam } = useAppSearchParams();

  const [validateOTPModal, setValidateOTPModal] = React.useState<boolean>(false);
  const [verifyIdentityModal, setVerifyIdentityModal] = React.useState<boolean>(false);
  const [phoneNumber, setPhoneNumber] = React.useState<string>('');
  const [smileIDtrigger, setSmileIDtrigger] = React.useState<boolean>(false);
  const [userDetails, setUserDetails] = React.useState<IEnhancedKYC>({
    source_sdk: 'rest_api',
    source_sdk_version: '1.0.0',
    signature: process.env.REACT_APP_SMILE_ID_SIGNATURE as string,
    timestamp: '2023-11-10T10:33:51.594Z',
    partner_params: {
      user_id: '',
      job_id: '',
      job_type: 5,
    },
    country: 'NG',
    id_type: 'PHONE_NUMBER',
    id_number: '',
    first_name: '',
    last_name: '',
    dob: '',
    bank_code: '',
    callback_url: 'https://www.ajocard.com',
    partner_id: '127',
  });

  const merchantId = getSearchParam('merchantId');
  const proxy_url = 'https://thingproxy.freeboard.io/fetch/';

  const {
    data: smileIDResponse,
    error,
    isLoading: smileIdLoading,
  } = useAppQuery<IEnhancedKYCSyncResponse, Error>(
    ['users'],
    {
      url: `${proxy_url}${process.env.REACT_APP_SMILE_ID_BASE_URL_PROD}/v1/id_verification`,
      method: 'POST',
      data: userDetails,
    },
    {
      enabled: !smileIDtrigger,
    }
  );

  const handleGenerateOTPSuccess = () => {
    setValidateOTPModal(true);
    setUserDetails((prev) => {
      return {
        ...prev,
        id_number: phoneNumber,
      };
    });
  };

  const handleValidateOTPSuccess = () => {
    setSmileIDtrigger(true);
  };

  const handleCancelVerifyIdentity = () => {
    setVerifyIdentityModal(false);
  };

  const handleCancelValidateOtpModal = () => {
    setVerifyIdentityModal(false);
    setValidateOTPModal(false);
  };

  React.useEffect(() => {
    if (!!smileIDResponse) {
      setValidateOTPModal(false);
      setVerifyIdentityModal(true);
    }
  }, [smileIDResponse]);

  React.useEffect(() => {
    if (!!error) {
      message.error(error);
    }
  }, [error]);

  useLastUrl({ noAuthFeature: true });

  return (
    <main style={{ height: '80vh' }} className="d-flex justify-content-between flex-column">
      <nav style={{ background: '#001ddd' }} className="w-100 d-flex align-center justify-content-between py-4 px-6">
        <img className="img-fluid" style={{ width: '200px' }} src="/img/bokku-logo.png" alt="bokku-logo" />
      </nav>
      <Container maxWidth="lg">
        {/* <h1>{merchantId}</h1> */}
        <div className="d-flex align-start justify-content-between w-100" style={{ gap: '4rem' }}>
          <div className="w-100">
            <div>
              <Typography.Title level={4}>
                Got your eyes on something big? With Save Now, Buy Later, AjoCard helps you put money aside gradually for your major purchases without
                the pressure of upfront payment.
              </Typography.Title>
              <Typography.Title level={4}>
                Powered by our CBN-licensed and NDIC-insured Microfinance Bank, this product gives you a safe, structured way to reach your financial
                goals whether it’s a gadget, home upgrade, or personal milestone.
              </Typography.Title>
              <Typography.Title level={4}>Start saving today and buy when you're ready the smart way.</Typography.Title>
              <Typography.Title level={3}>PROCESS</Typography.Title>
            </div>
            <ul>
              <li>
                <Typography.Text>Enter your phone number</Typography.Text>
              </li>
              <li>
                <Typography.Text>Create your PIN</Typography.Text>
              </li>
              <li>
                <Typography.Text>Receive funding instructions</Typography.Text>
              </li>
            </ul>
          </div>
        </div>
      </Container>
      <div className="w-100">
        <div className="mx-auto d-flex align-center" style={{ width: 'max-content', gap: '1rem' }}>
          <Typography.Text>Powered by</Typography.Text>
          <div className="d-flex align-center">
            <img className="img-fluid" src="/logo.svg" alt="ajocard-logo" />
            <h4 className="m-0">AjoCard</h4>
          </div>
        </div>
      </div>
    </main>
  );
};

export default SNBLIdentify;
